import React from 'react';
import { Text, View } from '@react-pdf/renderer';

import GeneralPageLayout from './GeneralPageLayout';

const Contents = ({
  label,
  text,
  description = null,
}): JSX.Element => {
  return (
    <View style={{
      marginBottom: 18,
    }}>
      <Text
        style={{
          fontFamily: 'Courier',
          fontSize: 12,
          marginBottom: 4,
        }}
      >
        {label}
      </Text>
      <Text style={{
        fontFamily: 'Times-Roman',
        fontSize: 30,
      }}>
        {text}
      </Text>
      <Text
        style={{
          fontFamily: 'Helvetica',
          fontSize: 14,
          lineHeight: 1.14,
          marginBottom: 10,
          marginTop: 2,
        }}>
        {description}
      </Text>
    </View>
  );
};

const TableOfContents = ({
  primaryBrand,
  radius,
  uuid,
  zipCode,
  totalpopulation_est,
}): JSX.Element => {
  return (
    <GeneralPageLayout
      sectionTypeText="Explore Your Toolkit"
      footerText={uuid}
      textColor="#FFF"
      backgroundColor={primaryBrand.colors.dark}
    >
      <Contents
        label="Section 1"
        text="Community Insights"
        description={`Get to know the community living within a ${radius}-mile radius of ZIP code ${zipCode}. See reported age, race, ethnicity, and English proficiency of the estimated ${totalpopulation_est} people living in the area. Assess completion rates for common preventative screenings. Review a breakdown of common types of providers serving the region.`} />
      <Contents
        label="Section 2"
        text="Top AI-Informed Themes"
        description="Discover key themes of risk factors that may have the most impact on avoidable healthcare utilization in the community. These themes were selected by the Health Equity AI behind radian." />
      <Contents
        label="Section 3"
        text="Community-Facing Materials"
        description="Encourage individuals in the community to act on the opportunities raised in this report. Materials in this section match AI-generated portraits with the demographics of the region covered. Shareable materials have been created for each AI-informed theme. They may be printed or shared digitally on sites like LinkedIn, Facebook, Twitter, and Instagram." />
      <Contents
        label="Section 4"
        text="Clinician Resources"
        description="Unsure where to start addressing the opportunities surfaced by radian? Peruse this section to find actionable, evidence-based clinical guidance for reducing health inequities within your community." />
    </GeneralPageLayout>
  );
};

export default TableOfContents;
